<template>
    <div class="emap-flow-toolbar">
      <footer-buttons :buttons="buttons" @btn-click="btnClick" :limit-more="limitMore"></footer-buttons>
      <!-- 转办 -->
      <change-assignee 
        v-model="changeAssigneePopup" 
        :options="cur_btn" 
        :taskid="taskid"
        :defkey="defkey" 
        @on-confirm="changeAssigneeConfirm" 
        v-if="cur_btn.commandType === 'changeAssignee'"
      ></change-assignee>
      <!-- 流程状态 -->
      <emap-flow-steps-m v-model="processStatusPopup" :defkey="defkey" :taskid="taskid" :options="process_status" v-if="buttonsId.indexOf('processStatus') > -1"></emap-flow-steps-m>
      <!-- 催办 -->
      <van-popup v-model="urgentPopup" position="bottom" get-container="body" :style="{ width: '100%'}" v-if="buttonsId.indexOf('urgent') > -1">
        <van-form @submit="urgentConfirm" ref="urgent">
          <van-field
            v-model="urgentForm.content"
            name="content"
            :label="urgentLabel.contentText"
            placeholder="请输入"
            required
            maxlength="500"
            type="textarea"
            show-word-limit
            :rules="[{ required: true, message: '请填写催办内容' }]"
          />
          <van-field name="sendType" :label="urgentLabel.typeText" required>
            <template slot="input">
              <van-checkbox-group v-model="urgentForm.sendType" direction="horizontal">
                <van-checkbox 
                  v-for="(item, index) in sendType"
                  :key="index"
                  :name="item.id"
                  shape="square"
                >{{item.name}}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-row>
            <van-col span="12">
              <van-button block square @click="urgentPopup = false">{{cancelText}}</van-button>
            </van-col>
            <van-col span="12">
              <van-button type="info" block square native-type="submit">{{confirmText}}</van-button>
            </van-col>
          </van-row>
        </van-form>
      </van-popup>
      <!-- 加签 -->
      <add-assignee v-model="addAssigneePopup" :taskid="taskid" :defkey="defkey" @on-confirm="addAssigneeConfirm" v-if="cur_btn.commandType === 'addAssigneeTask'"></add-assignee>
      <!-- 减签 -->
      <del-assignee v-model="delAssigneePopup" :taskid="taskid" :defkey="defkey" @on-confirm="delAssigneeConfirm" v-if="cur_btn.commandType === 'deleteAssigneeTask'"></del-assignee>
      <!-- 流程轨迹 -->
      <van-popup v-model="processTrackPopup" position="bottom" get-container="body" :style="{ width: '100%', height: '100%'}" v-if="buttonsId.indexOf('processTrack') > -1">
        <div class="process-track-container">
          <div id="js-canvas" style="position:relative;height: 100%;padding-top: 20px;" ref="js-canvas"><span class="process-track-nodata">获取流程轨迹失败！</span></div>
        </div>
        <van-button type="info" block square @click="processTrackPopup = false">{{confirmText}}</van-button>
      </van-popup>
      <!-- 退回 -->
      <van-action-sheet v-model="backModal" title="退回" get-container="body" v-if="buttonsId.indexOf('turnback') > -1" >
        <emap-flow-next-step-m
          v-model="turnbackValue" 
          :taskId="taskid"
          :nodeurl="turnbackObj[cur_btn.backTo + 'Node']"
          :assigneeurl="turnbackObj[cur_btn.backTo + 'Assignee']"
          schema="simple"
          showNextNode
          echostyle="id"
          :nodelabel="turnbackObj.nodelabel"
          :assigneeslabel="turnbackObj.assigneeslabel"
          :onnodeverify="turnbackNodeResponse"
          ref="nextstep"
        ></emap-flow-next-step-m>
        <div class="back-footer">
          <van-button type="info" block @click="backConfirm" round>确定</van-button>
        </div>
      </van-action-sheet>
    </div>
</template>
<script>
  import ToolbarMixin from "mixins/emapflow-toolbar"
  import EmapFlowStepsM from './emap-flow-steps-m.vue'
  import EmapFlowNextStepM from './emap-flow-next-step-m.vue'
  import ChangeAssignee from './modals/change-assignee.vue'
  import AddAssignee from './modals/add-assignee.vue'
  import DelAssignee from './modals/del-assignee.vue'
  import FooterButtons from './features/footer-buttons.vue'

  export default {
    name: "emap-flow-toolbar-m",
    data() {
      return {
        cur_btn: {},
        actionPopup: false,
        changeAssigneePopup: false,
        processStatusPopup: false,
        urgentPopup: false,
        addAssigneePopup: false,
        delAssigneePopup: false,
        processTrackPopup: false,
        cancelText: '取消',
        confirmText: '确定',
        urgentLabel: {
          contentText: '催办内容',
          typeText: '催办方式'
        },
        urgentForm: {
          content: '', 
          sendType: []
        },
        backModal:  false,
      }
    },
    components: {
      EmapFlowStepsM,
      EmapFlowNextStepM,
      ChangeAssignee,
      FooterButtons,
      AddAssignee,
      DelAssignee
    },
    mixins: [ToolbarMixin],
    props: {
      sendType: {
        type: Array,
        default: () => {
          return []
        }
      },
      limitMore: {
        type: Number,
        default: 2,
        validator: function(value) {
          return [1,2,3,4].indexOf(value) > -1;
        }
      }
    },
    methods: {
      btnClick(btn) {
        this.cur_btn = btn;
        if(typeof this.onverify === 'function') {
          let result = this.onverify(btn, this.onverifyCallback);
          // 兼容原先写法
          if(result === true) {
            this.onverifyCallback(btn);
          }
        } else {
          this.onverifyCallback(btn);
        }
      },
      onverifyCallback(btn) {
        let noDisabled = ["processStatus","urgent","addAssigneeTask","deleteAssigneeTask","changeAssignee","processTrack"];
        this.buttons = this.buttons.map( item => {
          if(item.commandType === btn.commandType && noDisabled.indexOf(item.commandType) === -1) {
            if(btn.commandType === 'turnback') {
              if(btn.backTo.indexOf("custom") === -1 ) item.disabled = true;
            } else {
              item.disabled = true;
            } 
          }
          return item
        });

        if(noDisabled.indexOf(btn.commandType) > -1 || (btn.commandType === 'turnback' && btn.backTo.indexOf("custom")> -1) ) {
          this.$nextTick(() => {
            this.switchAction(btn)
          })
        } else {
          this.doCommonRequest(btn);
        }
      },
      switchAction(item) {
        switch(item.commandType) {
          case 'changeAssignee':
            this.changeAssigneePopup = true;
            break;
          case 'processStatus':
            this.processStatusPopup = true;
            this.doCommonRequest(item);
            break;
          case 'urgent':
            this.$toast('开发中');
            // this.urgentPopup = true;
            // this.$nextTick(function(){
            //   this.$refs.urgent.resetValidation('content')
            // })
            break;
          case 'addAssigneeTask': 
            this.addAssigneePopup = true;
            break;
          case 'deleteAssigneeTask':
            this.delAssigneePopup = true;
            break;
          case 'processTrack':
            this.processTrackPopup = true;
            this.doCommonRequest(item);
            break;
          case 'turnback': 
            this.backModal = true;
            break;
        }
      },
      // 转办--单选
      changeAssigneeConfirm(id) {
        this.cur_btn.assignee = id;
        // if(this.fileexistverify && this.fileexistverify(this.cur_btn) === true) return;
        this.doCommonRequest(this.cur_btn);
      },
      // 加签
      addAssigneeConfirm(taskId, assignees) {
        this.cur_btn.taskId = taskId;
        this.cur_btn.assignees = assignees;
        this.doCommonRequest(this.cur_btn).then(data => {
          if(data && data.succeed){
            if(!this.closemessageinfo) {
              this.$toast("加签成功");
            }
          } else {
            if(!this.closemessageinfo) {
              this.$toast("加签失败");
            }
          }
        })
      },
      // 减签
      delAssigneeConfirm(taskId, assignees) {
        this.cur_btn.taskId = taskId
        this.cur_btn.assignees = assignees
        this.doCommonRequest(this.cur_btn).then(data => {
          if(data && data.succeed){
            if(!this.closemessageinfo) {
              this.$toast("减签成功");
            }
          } else {
            if(!this.closemessageinfo) {
              this.$toast("减签失败");
            }
          }
        })
      },
      // 催办
      urgentConfirm() {
        // ...
      },
      backConfirm() {
        let valid = this.$refs["nextstep"].validate();
        if(valid) {
          this.cur_btn.backTo = this.turnbackValue.nextNodeId;
          this.cur_btn.nextAssignees = this.turnbackValue.nextAssignees;
          this.backModal = false;
          this.buttons = this.buttons.map(btn => {
          if(btn.commandType === 'turnback') btn.disabled = true;
            return btn
          });
          this.doCommonRequest(this.cur_btn);
        }
      }
    },
    created() {
      // ...
    }
  }
</script>
<style lang="css" scoped>
  .emap-flow-toolbar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .emap-flow-assignee {
    padding: 0 17px;
  }
  .emap-flow-assignee-label {
    float: left;
    width: 84px;
    padding: 8px 0;
  }
  .emap-flow-assignee-content {
    margin-left: 84px;
    height: 160px;
    overflow-y: auto;
    padding: 4px 0 10px;
  }
  .emap-flow-tag {
    margin: 2px 4px 2px 0;
  }
  .emap-flow-pick-m .tree-mask {
    z-index: 9999;
  }
  .process-track-container {
    height: calc(100% - 42px);
    overflow: auto;
  }
  .process-track-nodata {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: red;
  }
  .bpmn-startevent .djs-visual circle {
    fill: rgb(6,180,163)!important;
  }
  .bpmn-usertask .djs-visual rect {
    fill: rgb(32,172,233)!important;
  }
  .bpmn-usertask .djs-visual text{
    fill:rgb(255,255,255)!important;
  }
  .bpmn-endevent .djs-visual circle {
    fill: rgb(249,103,102)!important;
  }
  .bpmn-usertask-actived .djs-visual rect {
    stroke: rgb(249,103,102)!important;
    stroke-width: 4px!important;
  }
  .bpmn-sequenceflow .djs-visual path {
    stroke: rgb(88,88,88)!important;
    marker-end: url('#sequenceflow-end')!important;
  }
  .bpmn-sequenceflow-passed .djs-visual path {
    stroke: rgb(205,213,224)!important;
    marker-end: url('#sequenceflow-end-passed')!important;
  }
  .bpmn-startevent-passed .djs-visual circle {
    fill: rgb(237,241,244)!important;
    stroke: rgb(205,213,224)!important;
  }
  .bpmn-endevent-passed .djs-visual circle {
    fill: rgb(237,241,244)!important;
    stroke: rgb(205,213,224)!important;
  }
  .bpmn-usertask-passed .djs-visual rect {
    fill: rgb(237,241,244)!important;
    stroke: rgb(205,213,224)!important;
  }
  .bpmn-usertask-passed .djs-visual text{
    fill: rgb(205,213,224)!important;
  }
  .back-footer {
    padding: 3px 10px;
  }
</style>